<template>
  <v-app id="app">
    <v-select
      :items="dropdown_icon"
      label="Segmented Btn"
      @change="updateUrl"
      :value="activeStation"
    ></v-select>
    <div class="ng-app-embedded">
      <div ui-view class="microsite embedded-radio-player" data-playerwidth="281px" data-playertype="web_embedded"
           :data-playstation="activeStation" data-autoplay="true"
           data-apikey="df04ff67dd3339a6fc19c9b8be164d5b5245ae93"></div>
    </div>
    <div>{{token}}</div>
    <div :key="item" v-for="item in text">{{item}}<br/></div>
  </v-app>
</template>

<script>

  /*eslint-disable */
  import * as annyang from 'annyang';
  import * as stringSimilarity from 'string-similarity';
  const dateFormat = require('dateformat');
  export default {
    async created() {
      this.getStationValueFromUrl()
      annyang.addCallback('result', (speechRecognitionResult) => {
        speechRecognitionResult.map(text => {
          this.findNamesInText(text)
        })

        this.text = new Set([...this.text, ...speechRecognitionResult.map(text => text.toLowerCase() + ' ' + dateFormat(new Date(), 'h:MM:ss TT'))])
      });
      annyang.setLanguage('de-DE')
      annyang.start();
    },
    name: 'app',
    data() {
      return {
        text: '',
        token: '',
        names: [['friedrich', 'kefer']],
        activeStation: '',
        radioStations: {
          'antennebayern': {
            sendText: 'Antenne Bayern anrufen',
            clickUrl: 'https://www.antenne.de/programm/aktionen/verdoppel-dein-gehalt/'
          },
          'dieneue1077rockpop': {
            sendText: 'DIE_NEUE_1077 anrufen',
            clickUrl: 'https://dieneue1077.de/wir-zahlen-deine-rechnung'
          },
          '1046rtl': {
            sendText: '1046rtl anrufen',
            clickUrl: 'https://www.104.6rtl.com/gewinnen/gewinnspiele/arno-zahlt-deine-rechnung-fuer-1-jahr-id320481.html'
          },
          'antenne1': {
            sendText: 'Antenne1 anrufen',
            clickUrl: 'https://www.antenne1.de/programm/aktionen/egal-was-wir-zahlen-das.html'
          },
          'antennemv': {
            sendText: 'antennemv anrufen',
            clickUrl: 'https://www.antennemv.de/aktionen/antenne-mv-zahlt-ihre-rechnung'
          }
        },
        dropdown_icon: [
          'antennebayern',
          'antenne1',
          '1046rtl',
          'dieneue1077rockpop',
          'antennemv'
        ]
      }
    },
    methods: {
      writeScript() {
        const s = document.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.id = 'radio-de-embedded';
        s.src = '//www.radio.de/inc/microsite/js/full.js';
        document.getElementsByTagName('head')[0].appendChild(s);

      },
      getStationValueFromUrl() {
        const url = new URL(window.location.href);
        this.activeStation = url.searchParams.get('station')
        if (this.activeStation) {
          this.writeScript()
        }
      },
      updateUrl(station) {
        this.activeStation = station
        const params = new URLSearchParams(location.search);
        params.set('station', station);
        window.history.replaceState({}, '', `${location.pathname}?${params}`);
        location.reload()
      },
      findNamesInText(text) {
        this.names.map(names => {
          let totalMatch = 0
          let textMatch = ''
          names.map(name => {
            const similarity = stringSimilarity.findBestMatch(name, text.split(' '))
            totalMatch += similarity.bestMatch.rating
            textMatch += similarity.bestMatch.target + " "
          })
          const averageMatch = totalMatch / names.length
          if (averageMatch >= 0.8) {
            const station = this.radioStations[this.activeStation]
            fetch('https://fcm.googleapis.com/fcm/send', {
              method: 'POST',
              mode: 'cors',
              cache: 'default',
              credentials: 'same-origin',
              withCredentials: true,
              headers: new Headers({
                'Authorization': 'key=AAAA_vCLKyI:APA91bHtVbW_plGEJwFB41Al0e1Cpmx44-2xYCZxQCh1mA4bo4QuUdjocQrftphEdtaTxdi-17grFEaVvVT2wjOF7VzjfLlxOo7AGkpudAFhuCusruUmZP8LMOvauqrKnxfJLNWwK9FL',
                'Content-Type': 'application/json'
              }),
              redirect: 'follow', // manual, *follow, error
              body: JSON.stringify({
                'notification': {
                  'title': textMatch + ' ' + dateFormat(new Date(), 'h:MM:ss TT'),
                  'body': station.sendText,
                  'click_action': station.clickUrl,
                  'icon': 'http://url-to-an-icon/icon.png'
                },
                'to': 'eKV7phsIWBqJpqrkFrHyUA:APA91bHpU9JJIcRSzOSe5iHnhMxmBxaPgtOOdIqSomjMUNxfu7ralT0AtZTfdjuhPQN9P4oHWnurIQTHf04iYB6aGbfOtpvnmMlvST3BABr0GSXZDx1_MP-QykC8gUIjaHG5pFvfDFyC'
              }) // body data type must match "Content-Type" header
            })
          }

        })
      }
    },
    components: {}
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>
